import { switcher } from './utils';

export const ADD_REQUEST = 'ADD_REQUEST';
export const TRIED_REQUEST = 'TRIED_REQUEST';
export const COMPLETE_REQUEST = 'COMPLETE_REQUEST';

export default switcher([], {
    [ADD_REQUEST]: (state, action) => {
        return [...state, action.payload];
    },
    [TRIED_REQUEST]: (state, action) => {
        const { id, timestamp } = action.payload;
        return state.map(request => {
            if (request.id === id) {
                return {
                    ...request,
                    lastTried: timestamp,
                };
            }
            return request;
        });
    },
    [COMPLETE_REQUEST]: (state, action) => {
        const { id } = action.payload;
        return state.filter(request => request.id != id);
    },
});

const tried = request => request.lastTried || 0;

const backoff = 60000;

export const selectNextRequest = state =>
    state.find(request => tried(request) < Date.now() - backoff);



// WEBPACK FOOTER //
// ./src/reducers/request_queue.js